import {
  AnalyticsModules,
  SalesEnablementActionType,
  useAnalytics
} from '@setvi/shared/hooks';
import {
  SAccordion,
  SegmentedSwitch,
  SRoundedContainer
} from '@setvi/shared/components';
import {
  ProductDetailsAccordion,
  productDetailsAccordions,
  ProductDetailsTab,
  useProductInfo
} from 'componentsV2/product/details/content/subpages/product-info/hook';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { ProductInfoProps } from 'componentsV2/product/details/content/subpages';
import { AILoader } from 'pages/products/components';
import { Box } from '@material-ui/core';
import {
  NoSalesEnablement,
  SalesKitFeedback
} from 'componentsV2/product/details/content/subpages/sales-enablement/components';
import { loadingSalesEnablementMessages } from 'pages/products/components/ai/loader/messages';
import { AccordionsContainer, AIOverviewContent, Container } from './styled';

export const MobileProductInfo = ({ product }: ProductInfoProps) => {
  const {
    tab,
    setTab,
    salesKit,
    expandedAccordion,
    setExpandedAccordion,
    salesKitLoading,
    salesKitData,
    options
  } = useProductInfo({ product });

  const { captureAnalytics } = useAnalytics();
  const flags = useFlags();

  return (
    <Container>
      <AccordionsContainer>
        {flags?.salesEnablement && !!salesKitData && (
          <SegmentedSwitch<number>
            value={tab}
            style={{ margin: '0 auto' }}
            setValue={(val: ProductDetailsTab) => {
              if (val === ProductDetailsTab.AIDETAILS) {
                captureAnalytics(
                  {
                    productSKU: product.sku,
                    item: 'AI Overview',
                    content: salesKitData?.[0]?.content || '-',
                    actionType: SalesEnablementActionType.ItemClick
                  },
                  AnalyticsModules.SalesEnablement
                );
              }

              setTab(val);
              setExpandedAccordion(
                val === ProductDetailsTab.DETAILS
                  ? productDetailsAccordions.map(({ title }) => title)
                  : ['AI Overview'] // Only expand AI Overview if it exists
              );
            }}
            options={options}
          />
        )}

        {/* Render regular description */}
        {tab === ProductDetailsTab.DETAILS &&
          productDetailsAccordions.map(
            ({ title, content }: ProductDetailsAccordion) => (
              <SRoundedContainer style={{ padding: '0 16px' }}>
                <SAccordion
                  key={title}
                  title={title}
                  content={content(product)}
                  expanded={expandedAccordion.includes(title)}
                  onClick={val =>
                    setExpandedAccordion(prev => {
                      const isExpanded = prev.includes(title);
                      return isExpanded
                        ? prev.filter(item => item !== title)
                        : [...prev, val];
                    })
                  }
                />
              </SRoundedContainer>
            )
          )}

        {/* Render AI Overview */}
        {tab === ProductDetailsTab.AIDETAILS && flags?.salesEnablement && (
          <SRoundedContainer style={{ padding: '0 16px' }}>
            <SAccordion
              key="AI Overview"
              title="AI Overview"
              content={
                salesKitLoading ? (
                  <AIOverviewContent>
                    <AILoader messages={loadingSalesEnablementMessages} />
                  </AIOverviewContent>
                ) : (
                  <>
                    {salesKitData?.[0]?.content ? (
                      <Box
                        dangerouslySetInnerHTML={{
                          __html: salesKitData?.[0]?.content || '-'
                        }}
                      />
                    ) : (
                      <AIOverviewContent>
                        <NoSalesEnablement
                          disabled={salesKit?.disabled || false}
                          metadataError={false}
                        />
                      </AIOverviewContent>
                    )}
                  </>
                )
              }
              rightSection={
                <SalesKitFeedback
                  product={product}
                  label="How can we improve AI Overview?"
                />
              }
              expanded={expandedAccordion.includes('AI Overview')}
              onClick={val =>
                setExpandedAccordion(prev => {
                  const isExpanded = prev.includes('AI Overview');
                  return isExpanded
                    ? prev.filter(item => item !== 'AI Overview')
                    : [...prev, val];
                })
              }
            />
          </SRoundedContainer>
        )}
      </AccordionsContainer>
    </Container>
  );
};
